<div _ngcontent-c0="" class="app-content ui basic segment container">
  <div _ngcontent-c3="" class="ui basic segment wrapper">

    <div class="full-width ui basic segment">

      <h2 class="ui header"> Complaint Form </h2>

      <div class="ui attached message" *ngIf="!showMessage">
        <div class="header">
          Thank you for using the Company Registration Portal.
        </div>
        <p>Please use this form if you encounter any issue while using the portal and we will get back to you very soon.
        </p>
      </div>

      <div class="ui positive attached message" *ngIf="showMessage">
        <div class="header">
          Your complaint has been logged successfully
        </div>
      </div>

      <form class="ui form attached fluid segment " [formGroup]="complaintForm" (ngSubmit)="save()"
      novalidate=""  autocomplete="off">
        <div class="required field" formGroupName="complaintCategory">
          <label>Category</label>
          <select formControlName="id" class="">
            <option value="0">-Select Category-</option>
            <option *ngFor="let category of complaintCategory" value="{{category.id}}">{{category.name}}</option>
          </select>
        </div>
        <div class="required field">
          <label>Description</label>
          <textarea formControlName="description" placeholder="Description" type="text"
            class=""></textarea>
        </div>
        <div class="required field">
          <label>Name</label>
          <input formControlName="name" name="name" placeholder="Name" type="text" class="">
        </div>
        <div class="required field">
          <label>Email</label>
          <input formControlName="email" name="email" placeholder="Email" type="email" class="">
        </div>
        <div class="required field">
          <label>Phone Number</label>
          <input formControlName="phone" name="phone" placeholder="Phone Number" type="text" class="">
        </div>
        <button class="ui fluid large primary submit button" [disabled]="complaintForm.invalid" type="submit">
          Submit
        </button>
      </form>
    </div>

  </div>
</div>
